export default __webpack_public_path__ + "static/media/close-icon.00e47569.svg";